import React, { useEffect } from "react";
import DataGrid from "@shared/DataGrid";
import SelectOperator from "@shared/SelectOperator";
import { Button, Form, Grid, Header } from "semantic-ui-react";
import {
  useRevenueTermsProfilesOptions,
  useRevenueTermsProfilesOperator,
  useRevenueTermsProfilesGrid,
} from "@hooks/useRevenueTermsProfilesState";
import OptionsList from "../systemAdmin/OptionsList";
import { validateOptions } from "../../helpers/options";

const ProfileEditor = () => {
  const {
    options,
    profileLoading,
    onNewProfileClick,
    activeRow,
    selectedOperator,
    onProfileSave,
    onOptionChange,
    fetchNewProfile,
  } = useRevenueTermsProfilesOptions();

  const isValid = validateOptions(options);

  useEffect(fetchNewProfile, [selectedOperator]);

  return (
    <div className="p-1">
      <Header content={activeRow?.id ? "Edit Profile" : "New Profile"} />
      <OptionsList
        className="mb-1"
        options={options}
        onChange={onOptionChange}
        loading={profileLoading}
      />
      <div className="mt-1">
        <Button
          color="blue"
          content="New"
          icon="plus"
          onClick={onNewProfileClick}
        />
        <Button
          positive
          content="Save"
          icon="save"
          disabled={!isValid}
          onClick={() => onProfileSave(true)}
        />
      </div>
    </div>
  );
};

const ProfileList = () => {
  const {
    headerDef,
    loading,
    activeRow,
    data,
    rowDef,
    onRowClick,
    onActiveRowChange,
    span,
  } = useRevenueTermsProfilesGrid();

  useEffect(onActiveRowChange, [activeRow]);

  return (
    <DataGrid
      groupHeadings={span}
      headings={headerDef}
      activeRow={activeRow}
      data={data}
      loading={loading}
      rowDef={rowDef}
      hideOverflow
      onRowClick={onRowClick}
      fullHeight
    />
  );
};

const RevenueTermsProfiles = () => {
  const { operators, fetchProfiles, selectedOperator, onOperatorChange } =
    useRevenueTermsProfilesOperator();

  useEffect(fetchProfiles, [selectedOperator]);

  return (
    <Grid className="height-100 gs-flex-container-vertical">
      <Grid.Row>
        <Grid.Column width="16">
          <Header>Net Revenue Terms Profiles</Header>
          <Form>
            <Form.Field inline>
              <label>Select Operator:</label>
              <SelectOperator
                className="min-width"
                operators={operators}
                value={selectedOperator}
                onChange={onOperatorChange}
              />
            </Form.Field>
          </Form>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="flex-stretch">
        <Grid.Column
          width={selectedOperator ? 11 : 16}
          className="gs-flex-container-vertical"
        >
          <ProfileList />
        </Grid.Column>
        {selectedOperator && (
          <Grid.Column width="5" className="gs-flex-container-vertical">
            <ProfileEditor />
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
};

export default RevenueTermsProfiles;
